import React from 'react';
export var ChevronUpIcon = function ChevronUpIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "28",
    height: "17",
    viewBox: "0 0 28 17",
    fill: "none"
  }, React.createElement("path", {
    d: "M28 14L25.17 16.83L14 5.66L2.82 16.83L3.98165e-06 14L14 1.66948e-07L28 14Z"
  }));
};